<template>
    <div class="link-cta-btns-container">
        <div class="title">{{ $t("home.rightCTATitle") || "&nbsp;" }}</div>

        <transition name="cta-anim">
            <CTAButton
                position="right"
                v-if="ready"
                href="https://www.facebook.com/argo.group.news/"
            >
                <img :src="require('@/assets/facebook-logo.png')" />
            </CTAButton>
        </transition>

        <transition name="cta-anim">
            <CTAButton position="right" v-if="ready" href="https://www.linkedin.com/company/ar-go/">
                <img :src="require('@/assets/linkedin-logo.png')" />
            </CTAButton>
        </transition>

        <transition name="cta-anim">
            <CTAButton
                position="right"
                v-if="ready"
                href="https://www.youtube.com/channel/UC75UOvl-cpQe7rMtpRC7Sgw"
            >
                <img :src="require('@/assets/youtube-logo.png')" />
            </CTAButton>
        </transition>

        <transition name="cta-anim">
            <CTAButton
                position="right"
                v-if="ready"
                href="https://www.instagram.com/argo_augmented_doc/"
            >
                <img :src="require('@/assets/instagram-logo.png')" />
            </CTAButton>
        </transition>

        <transition name="cta-anim">
            <CTAButton v-if="ready" position="right" href="https://twitter.com/argo_group_news">
                <img :src="require('@/assets/twitter-logo.png')" />
            </CTAButton>
        </transition>
    </div>
</template>
<script lang="ts">
import CTAButton from "@/components/CTAButton.vue";
export default {
    name: "ContactCTAButtons",
    components: {
        CTAButton
    },
    data() {
        return {
            ready: false
        };
    },
    mounted() {
        setTimeout(() => {
            this.ready = true;
        }, 200);
    }
};
</script>
<style scoped>
.link-cta-btns-container {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    --animation-duration: 150;
}

.title {
    color: var(--screenTextColor);
    font-size: 0.8em;
    font-weight: bold;
    margin-bottom: 5px;
    margin-left: 3px;
}

.cta-button > * {
    margin-right: 8%;
}

.cta-button > img {
    height: 55%;
}

.cta-button:nth-of-type(2) {
    animation-delay: calc(var(--animation-duration) * 1ms);
    transition-delay: calc(var(--animation-duration) * 1ms);
}

.cta-button:nth-of-type(3) {
    animation-delay: calc(var(--animation-duration) * 2ms);
    transition-delay: calc(var(--animation-duration) * 2ms);
}

.cta-button:nth-of-type(4) {
    animation-delay: calc(var(--animation-duration) * 3ms);
    transition-delay: calc(var(--animation-duration) * 3ms);
}

.cta-button:nth-of-type(5) {
    animation-delay: calc(var(--animation-duration) * 4ms);
    transition-delay: calc(var(--animation-duration) * 4ms);
}
</style>
